import { FallbackProvider } from "@ethersproject/providers";

export const getCurrentBlockTimestamp = (provider: FallbackProvider) =>
  provider
    .getBlockNumber()
    .then((blockNumber) => provider.getBlock(blockNumber))
    .then((block) => block.timestamp);
